import '../stylesheets/application.scss';

import Sittercity from './sittercity';
import App from '../apps/App.vue';
import { setupApollo } from '../lib/apollo_setup';

import router from '../router';
import store from '../store';

import setupFooter from '@/lib/setup_footer';

document.addEventListener('DOMContentLoaded', () => {
  const appNode = document.getElementById('app-rerouted');

  const apolloProvider = setupApollo();

  if (appNode === null) {
    console.log('Continuing to entrypoints');
  } else {
    new Sittercity({
      router,
      store,
      apolloProvider,
      name: 'Sittercity',
      render(createElement) {
        return createElement(App);
      },
    }).$mount('#app-rerouted');
  }

  setupFooter();
});
